export const MESSAGE_PREFIX = 'livechat:'
export const PLUGIN_ID = 'marketplace'

// POST MESSAGE EVENTS SUPPORTED IN THE MARKETPLACE AND AGENT APP
export const PM_EVENT = {
  LOADED: 'loaded',
  NAVIGATE: 'navigate',
  PRELOAD: 'preload',
  ROUTE_CHANGE: 'route_change',
  QUERY_STRING_CHANGE: 'query_string_change',
  APP_INSTALLED: 'app_installed',
  APP_REMOVED: 'app_removed',
  APP_EVENT: 'app_event',
  APP_PURCHASED: 'app_purchased',
  CART_PURCHASED: 'cart_purchased',
  CART_UPDATED: 'cart_updated',
  MARKETPLACE_CART_UPDATE: 'marketplace_cart_update',
  REFRESH_INSTALLED_APPS: 'refresh_installed_apps',
  REFRESH_CART: 'refresh_cart',
  REFRESH_SUBSCRIPTION_INFO: 'refresh_subscription_info',
  MAILTO: 'mailto',
  BREADCRUMBS: 'breadcrumbs',
  CREDENTIALS: 'credentials',
}

// POST MESSAGE EVENTS RELATED TO ONE CLICK PAYMENTS PROCESS
export const PM_PAYMENT_EVENT = {
  REGISTER_TRANSACTION_PENDING: 'register_transaction_pending',
  REGISTER_TRANSACTION_SUCCESS: 'register_transaction_success',
  REGISTER_TRANSACTION_FAILURE: 'register_transaction_failure',
  TRANSACTION_DECLINED: 'transaction_declined',
  TRANSACTION_ACCEPTED: 'transaction_accepted',
  TRANSACTION_FAILED: 'transaction_failed',
  CHECK_ONBOARDING: 'check_onboarding',
  UPDATE_BILLING_CYCLE: 'update_billing_cycle',
}
